module.exports = __webpack_public_path__ + "img/work.f25422a4.svg";